import { Assets } from '@air/api';
import { useQuery } from '@tanstack/react-query';

import { useCurrentClipPermissions } from '~/components/PrivateAssetModal/hooks/useCurrentClipPermissions';
import { getAssetCustomFieldsKey } from '~/constants/react-query-keys';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { canSeeAssetCustomFields } from '~/utils/permissions/assetPermissions';

export const usePrivateAssetCustomFieldsData = (assetId: string | undefined) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;
  const { clipPermissions } = useCurrentClipPermissions();
  const canViewCustomFields = canSeeAssetCustomFields(clipPermissions);

  return useQuery({
    queryKey: getAssetCustomFieldsKey(assetId),
    queryFn: () => Assets.listCustomFields({ workspaceId: workspaceId!, assetId: assetId!, options: { limit: 100 } }),
    enabled: !!workspaceId && !!assetId && canViewCustomFields,
  });
};
